// extracted by mini-css-extract-plugin
module.exports = {"banner":"__0lf9vC8q","close":"p7zlqpbo","label":"B9cTB9kh","alert":"aRnOT2i5","link":"PoeWIPb8"};